import {get as getProjection, Projection} from "ol/proj";

export function getViewProjectionName() {
    return window.settings.ViewProjection
}

export function getViewProjectionByName(name) {
    switch (name) {
        case 'EPSG:28992':
            return new Projection({
                code: 'EPSG:28992',
                extent: [-285401.92, 22598.08, 595401.92, 903401.92]
            })
        case 'EPSG:4326':
            return getProjection('EPSG:4326')
        case 'EPSG:31370':
            return new Projection({
                code: 'EPSG:31370',
                extent: [5000, 5000, 280000, 245000]
            })
        case 'EPSG:3812':
            return new Projection({
                code: 'EPSG:3812',
                extent: [300000, 150000, 700000, 300000]
            })
        default:
            return getProjection('EPSG:3857')
    }
}

export function isBelgium() {
    return getViewProjectionName() === 'EPSG:31370'
}

export function getViewProjection() {
    return getViewProjectionByName(getViewProjectionName())
}

export function getLatLonProjectionName() {
    return 'EPSG:4326'
}

export function getViewProjectionOgcName() {
    return "http://www.opengis.net/def/crs/EPSG/0/" + window.settings.ViewProjection.split(":")[1];

}
